import { useEffect, useState } from "react";

const MQ = "(max-width: 768px)";

export const isMobileDevice = () => {
  if (typeof navigator === "undefined") return false;
  const ua = /Android|iPhone|iPad|iPod|IEMobile|Opera Mini|Mobile/i.test(navigator.userAgent);
  const coarse = window.matchMedia?.("(pointer: coarse)").matches && window.matchMedia?.(MQ).matches;
  return ua || !!coarse;
};

export const isTouch = () => !!window.matchMedia?.("(hover: none)").matches;

export const useIsMobile = () => {
  const [mobile, setMobile] = useState(() => !!window.matchMedia?.(MQ).matches);
  useEffect(() => {
    const mq = window.matchMedia(MQ);
    const on = (e) => setMobile(e.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return mobile;
};
